import { FC } from 'react'
import { KTIcon } from '../../../../../../../_metronic/helpers'
import { InvoiceRowForm } from '../../core/_models'
import {FieldHelpLabel} from '../../../../../../../_metronic/helpers/components/FieldHelp'

type props = {
  title: string,
  invoiceItem: {
    invoiceItem: InvoiceRowForm | null | undefined,
    setInvoiceItem: React.Dispatch<React.SetStateAction<InvoiceRowForm | null | undefined>>
  },
}
const InvoiceItemEditModalHeader: FC<props> = ({ title, invoiceItem }) => {

  return (
    <div className='modal-header'>
      {/* begin::Modal title */}
      <h2 className='fw-bolder text-primary'>
        <FieldHelpLabel label={title} helpKey='section.body' />
      </h2>
      {/* end::Modal title */}

      {/* begin::Close */}
      <div
        className='btn btn-icon btn-sm btn-active-icon-primary'
        data-kt-invoices-modal-action='close'
        onClick={() => invoiceItem.setInvoiceItem(undefined)}
        style={{ cursor: 'pointer' }}
      >
        <KTIcon iconName='cross' className='fs-1' />
      </div>
      {/* end::Close */}
    </div>
  )
}

export { InvoiceItemEditModalHeader }
